import { SwipeableDrawer } from '@mui/material';
import { FaXMarkLightSvgIcon } from '../../../assets/icons/svgs';
import DrawerCloseTopLeftButton from '../../Modals/Drawers/DrawerCloseTopLeftButton';
import DrawerPuller from '../../Modals/Drawers/DrawerPuller';
import useDrawerOpenClose from '../../Modals/Drawers/hooks/useDrawerOpenClose';
import {
  DRAWER_TRANSITION,
  DRAWER_TRANSITION_DURATION,
} from '../../Modals/Drawers/utils';
import {
  drawerFromBottomPaperFullHeightStyles,
  modalCloseIconStyle,
  modalPaperRootBackdropStyles,
} from '../../Modals/utils';
import { isMobileScreen } from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';
import { useLocationSelectorContext } from '../LocationSelectorContext';
import AddNewLocationModalContent from './AddNewLocationModalContent';
import { AddNewLocationModalProvider } from './AddNewLocationModalProvider';
import AddNewLocationModalTitle from './AddNewLocationModalTitle';

const AddNewLocationModal = () => {
  const { isAddNewLocationModalOpen, setIsAddNewLocationModalOpen } =
    useLocationSelectorContext();

  const isOpen = isAddNewLocationModalOpen;
  const handleClose = () => setIsAddNewLocationModalOpen(false);

  const { isDrawerOpen, setDrawerToClose, drawerOpacity } = useDrawerOpenClose({
    isOpen,
    handleManualClose: handleClose,
  });

  return (
    <SwipeableDrawer
      onClose={setDrawerToClose}
      anchor="bottom"
      onOpen={() => console.log('')}
      open={isDrawerOpen}
      transitionDuration={DRAWER_TRANSITION_DURATION}
      disableBackdropTransition
      sx={{
        opacity: drawerOpacity,
        transition: DRAWER_TRANSITION,
        '& .MuiPaper-root': {
          ...drawerFromBottomPaperFullHeightStyles,
        },
        '& .MuiBackdrop-root': {
          ...modalPaperRootBackdropStyles,
          pointerEvents: isDrawerOpen ? 'auto' : 'none',
        },
      }}
    >
      {isDrawerOpen && (
        <>
          <DrawerCloseTopLeftButton />
          <FaXMarkLightSvgIcon
            onClick={setDrawerToClose}
            className="onClickEffect"
            size={fontSize['2xl']}
            style={{
              ...modalCloseIconStyle,
              visibility: isMobileScreen ? 'hidden' : 'visible',
              animation: 'fadeInOnRender 2.5s',
            }}
          />
        </>
      )}

      <DrawerPuller
        onClose={setDrawerToClose}
        isFullHeightDrawer={true}
        fullHeightContainerHeight={36}
      />

      <AddNewLocationModalTitle setDrawerToClose={setDrawerToClose} />

      <AddNewLocationModalContent handleModalClose={setDrawerToClose} />
    </SwipeableDrawer>
  );
};

const AddNewLocationModalWithProvider = () => {
  return (
    <AddNewLocationModalProvider>
      <AddNewLocationModal />
    </AddNewLocationModalProvider>
  );
};

export default AddNewLocationModalWithProvider;
